/**
 * Diskriminator für `TokenError`-Instanzen.
 *
 * - `INVALID_FORMAT`: Base64URL-Form, Länge oder Zeichensatz passen nicht.
 * - `VERSION_MISMATCH`: Erstes Byte ≠ `TOKEN_VERSION`.
 * - `FIELD_OVERFLOW`: Ein Feld überschreitet sein Bit-Limit (Encode).
 * - `TIMESLOT_OUT_OF_RANGE`: Plausibility-Check für `timeSlot` schlug fehl.
 */
export type TokenErrorKind =
  | 'INVALID_FORMAT'
  | 'VERSION_MISMATCH'
  | 'FIELD_OVERFLOW'
  | 'TIMESLOT_OUT_OF_RANGE';

/**
 * Strukturierter Fehler des TokenCodec.
 *
 * Trägt einen stabilen `kind`-Discriminator und optionale, **nicht-sensitive**
 * Kontextinformationen (`field`, `limit` etc.). Keine PHI im `message`.
 */
export class TokenError extends Error {
  public readonly kind: TokenErrorKind;
  public readonly field?: string;

  public constructor(kind: TokenErrorKind, message: string, field?: string) {
    super(message);
    this.name = 'TokenError';
    this.kind = kind;
    if (field !== undefined) {
      this.field = field;
    }
  }
}
